<template>
  <div class="wrapper-blog">
    <div class="container">
      <div class="title-wrap">
        <h2 style="color: #000">Asset</h2>
        <div class="circle-title-blog"></div>
        <p style="color: #000">Kami menjual asset De Heus Indonesia</p>
      </div>

      <div class="wrapper-content-blog">
        <div v-if="isLoading" class="loading-box">
          <div class="spinner"></div>
          <p>Loading asset...</p>
        </div>
        <div class="box" v-else v-for="(item, i) in properties" :key="i">
          <img
            class="cover-image"
            :src="item.cover_image || require('@/assets/images/prop-1.jpg')"
            alt=""
          />

          <div class="b-content">
            <p>
              <span
                v-for="(tag, j) in item.types.split(',')"
                :key="j"
                class="tag-style"
              >
                {{ tag.trim() }}
              </span>
            </p>

            <h5>{{ item.title }} - {{ item.district_name }}</h5>
            <p class="address">
              {{ item.subdistrict_name }}, {{ item.district_name }}
            </p>

            <p class="price">Rp {{ formatPrice(item.price) }}</p>
            <p class="specs">Luas {{ item.area }} m²</p>

            <router-link :to="`/asset/${item.slug}`" class="btn-detail">
              DETAIL ASSET
            </router-link>
          </div>
        </div>
      </div>

      <div class="wrapper-btn">
        <router-link to="/asset">Selengkapnya..</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AssetComp",
  data() {
    return {
      properties: [],
      isLoading: true,
      dummyProperties: [
        {
          slug: "dummy-1",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-2",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-3",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-3.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-4",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-5",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-6",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-3.jpg"),
          types: "RUMAH",
        },
        {
          slug: "dummy-7",
          title: "TANAH 3.615 m²",
          district_name: "Bogor",
          subdistrict_name: "Rumpin",
          price: "1003000000",
          area: "3615",
          cover_image: require("@/assets/images/prop-1.jpg"),
          types: "TANAH",
        },
        {
          slug: "dummy-8",
          title: "RUMAH MEWAH",
          district_name: "Jakarta Selatan",
          subdistrict_name: "Kebayoran",
          price: "2500000000",
          area: "500",
          cover_image: require("@/assets/images/prop-2.jpg"),
          types: "RUMAH",
        },
        // Tambah sampai minimal 8 dummy
      ],
    };
  },
  mounted() {
    this.loadProperties();
  },
  methods: {
    async loadProperties() {
      this.isLoading = true; // mulai loading
      try {
        const res = await fetch("https://cms-property.cjfnc.id/api/post-data");
        const json = await res.json();

        const data = json?.data ?? [];

        if (data.length >= 2) {
          this.properties = data.slice(0, 8);
        } else {
          this.properties = this.dummyProperties;
        }
      } catch (error) {
        console.error("Error fetch API, pakai dummy", error);
        this.properties = this.dummyProperties;
      } finally {
        this.isLoading = false; // selesai loading
      }
    },
    formatPrice(val) {
      return new Intl.NumberFormat("id-ID").format(val);
    },
  },
};
</script>

<style>
.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #ddd;
  border-top-color: #000;
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.tag-style {
  background: #aaaaaa;
  color: #000;
  margin-right: 5px;
  padding: 5px 15px;
  border-radius: 4px;
  font-size: 9px;
  text-transform: uppercase;
}
.btn-detail {
  background: #ff9600;
  border: 1px solid #ff9600;
  padding: 5px 20px;
  border-radius: 8px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}
.btn-detail:hover {
  background: transparent;

  color: #000;
}
.wrapper-blog {
  padding: 100px 0px 70px 0px;
  position: relative;
  z-index: 0;
}
.wrapper-content-blog {
  display: grid;
  width: 100%;
  column-gap: 20px;
  grid-template-columns: repeat(8, 1fr);
}
.wrapper-content-blog .box {
  grid-column: span 2;
  margin: 0px 5px;
  border-radius: 20px;
  box-shadow: 5px 10px 10px rgba(123, 123, 123, 0.1);
  margin-bottom: 20px;
}
.wrapper-content-blog .box img {
  width: 100%;
}
.wrapper-content-blog .box .b-content {
  padding: 20px;
}
.wrapper-content-blog .box .b-content p {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  text-align: left;
  color: #aaaaaa;
  margin-bottom: 10px;
}
p.price {
  color: #000 !important;
  font-size: 18px !important;
  font-weight: 800 !important;
}
p.specs {
  color: #000 !important;
  margin-bottom: 25px !important;
}
.wrapper-content-blog .box .b-content h5 {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  /* or 24px */
  text-align: left;
  display: flex;
  align-items: center;
  margin-top: 15px;
  color: #363636;
}
.wrapper-btn {
  margin: 0px 0px 0px 0px;
}
.wrapper-btn a {
  border: 1px solid #303030;
  filter: drop-shadow(10px 10px 40px rgba(164, 164, 164, 0.25));
  border-radius: 50px;
  justify-content: center;
  align-items: center;
  padding: 12px 70px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 150%;
  /* identical to box height, or 24px */

  text-align: center;
  text-decoration: none;
  transition: all 0.5s ease;
}
.wrapper-btn a:hover {
  border: 1px solid #ff9600;
  background: #ff9600;
  color: #fff;
  transition: all 0.5s ease;
}
@media (max-width: 1600px) {
  .title-wrap .circle-title-blog {
    left: 45.7%;
  }
}
@media (max-width: 1440px) {
  .title-wrap .circle-title-blog {
    left: 45.5%;
  }
  .wrapper-btn {
    margin: 70px 0px 0px 0px;
  }
  .wrapper-content-blog .box {
    margin: 0px 10px !important;
  }
}
@media (max-width: 1370px) {
  .title-wrap .circle-title-blog {
    left: 45.5%;
  }
  .wrapper-content-blog {
    margin-top: 70px;
  }
}
@media (max-width: 1285px) {
  .title-wrap .circle-title-blog {
    left: 44.9%;
  }
  .wrapper-blog {
    padding: 0px 40px 70px 40px;
  }
}
@media (max-width: 1200px) {
  .title-wrap .circle-title-tech {
    left: 39.4%;
  }
  .title-wrap .circle-title-blog {
    left: 44.5%;
  }
}
@media (max-width: 1024px) {
  .title-wrap .circle-title-blog {
    left: 44%;
  }
  .wrapper-blog {
    padding: 0px 20px 70px 20px;
  }
  .wrapper-content-blog .box {
    margin: 0px 5px !important;
  }
}
@media (max-width: 992px) {
  .title-wrap .circle-title-blog {
    left: 43.2%;
  }
  .wrapper-content-blog {
    column-gap: 0px;
  }
  .wrapper-content-blog .box .b-content h5 {
    font-size: 14px;
  }
}
@media (max-width: 820px) {
  .title-wrap .circle-title-blog {
    left: 42.2%;
  }
}
@media (max-width: 768px) {
  .title-wrap .circle-title-blog {
    left: 42%;
  }
  .wrapper-blog {
    padding: 0px 10px 70px 10px;
  }
}
@media (max-width: 600px) {
  .title-wrap .circle-title-blog {
    left: 38.5%;
  }
  .wrapper-content-blog .box {
    grid-column: span 8;
    margin: 0px 50px 30px 50px !important;
  }
  .wrapper-btn {
    margin: 30px 0px 0px 0px;
  }
}
@media (max-width: 500px) {
  .title-wrap .circle-title-blog {
    left: 34.5%;
  }
  .wrapper-content-blog .box {
    margin: 0px 10px 30px 10px !important;
  }
  .wrapper-content-blog .box .b-content {
    padding: 20px 20px 30px 20px;
  }
}
@media (max-width: 380px) {
  .title-wrap .circle-title-blog {
    left: 33%;
  }
}
@media (max-width: 285px) {
  .title-wrap .circle-title-blog {
    left: 31.5% !important;
    top: 6%;
    width: 40px;
    height: 40px;
  }
}
</style>
